interface Service {
  title: string;
  description: string;
  points: string[];
  icon: JSX.Element;
}

const services: Service[] = [
  {
    title: 'Website Building',
    description:
      'Marketing sites, landing pages, and storefronts that load fast, look sharp, and turn visitors into customers.',
    points: [
      'Business & marketing websites',
      'Landing pages & portfolios',
      'E-commerce storefronts',
      'Responsive, SEO-friendly builds',
    ],
    icon: (
      <svg className="h-[26px] w-[26px]" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="3" y="4" width="18" height="14" rx="2" stroke="currentColor" strokeWidth="1.6" />
        <path d="M3 8h18" stroke="currentColor" strokeWidth="1.6" />
        <circle cx="6" cy="6" r="0.6" fill="currentColor" />
        <circle cx="8.2" cy="6" r="0.6" fill="currentColor" />
        <path d="M8 21h8M12 18v3" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    title: 'App Building',
    description:
      'Custom web applications and internal tools built to handle the way your business actually operates.',
    points: [
      'Custom web applications',
      'SaaS platforms & dashboards',
      'Business & internal tools',
      'Scalable, mobile-friendly apps',
    ],
    icon: (
      <svg className="h-[26px] w-[26px]" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="6" y="2.5" width="12" height="19" rx="2.2" stroke="currentColor" strokeWidth="1.6" />
        <path d="M6 6h12M6 18h12" stroke="currentColor" strokeWidth="1.6" />
        <circle cx="12" cy="19.7" r="0.9" fill="currentColor" />
      </svg>
    ),
  },
];

function Services() {
  return (
    <section id="services" className="py-[88px]">
      <div className="wrap">
        <div className="mx-auto mb-12 max-w-[640px] text-center">
          <p className="eyebrow">What We Do</p>
          <h2>Websites and apps, built end to end</h2>
          <p className="section-lead">
            From a first landing page to a full internal platform, we handle design,
            development, and support.
          </p>
        </div>

        <div className="grid grid-cols-[repeat(auto-fit,minmax(280px,1fr))] gap-6">
          {services.map((service) => (
            <div className="card p-8" key={service.title}>
              <div className="mb-5 flex h-[52px] w-[52px] items-center justify-center rounded-xl bg-gradient-to-br from-blue to-teal text-white">
                {service.icon}
              </div>
              <h3 className="mb-2">{service.title}</h3>
              <p>{service.description}</p>
              <ul className="mt-[18px] list-none p-0">
                {service.points.map((point) => (
                  <li key={point} className="bullet before:bg-teal">
                    {point}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Services;
